import { LOCALES } from '../locales';

const de = {
    [LOCALES.GERMAN]: {
        'title': 'Boilerplate',
        'welcome': 'Herzlich willkommen'
    }
}

export default de;